import LogoSvg from "./logo.svg";

const Logo = ({ logoUrl, crewName }: { logoUrl?: string; crewName?: string }) => (
  <img src={logoUrl || LogoSvg} style={{ width: "100%", height: "100%", objectFit: "contain" }} alt={(logoUrl && crewName) || "NGFT"} />
);

export default Logo;
